import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import { StyleSheet, css } from "aphrodite";
import Marker from "./Marker";

class SimpleMap extends Component {
  static defaultProps = {
    center: { lat: -2, lng: 115 },
    zoom: 4.6,
  };

  render() {
    const { dataMember } = this.props;
    return (
      <div className={css(styles.map)}>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: process.env.REACT_APP_MAPS_API_KEY,
          }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          {dataMember !== null
            ? dataMember.data.map((item, idx) => (
              <Marker
                lat={item.latitude}
                lng={item.longitude}
                text={idx + 1}
                color="red"
              />
            ))
            : ""}
        </GoogleMapReact>
      </div>
    );
  }
}

export default SimpleMap;

const styles = StyleSheet.create({
  map: {
    height: "72vh",
    width: "100%",
    "@media (max-width: 768px)": {
      height: "40vh",
    },
  },
});
